module.exports = "<li ng-hide=\"tbSignInCtrl.isSignedIn\" id=\"tb-ui-signin-root\">\n    <button class=\"btn btn-primary\" ng-click=\"tbSignInCtrl.login()\">Log In</button>\n</li>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/user-auth/TbSignIn.tpl.html
// module id = wf9K
// module chunks = 1